export enum BindingType {
  Device,
  Pin,
  Biometric,
  Entersekt,
  FotoTAN
}